{
  "welcome": {
    "title": "Willkommen bei WrongStack",
    "subtitle": "Verbinde einen Anbieter, um loszulegen.",
    "heroTitle": "Wo möchtest du starten?",
    "heroTitleInProject": "Wo möchtest du in {{name}} starten?",
    "heroSubtitle": "Der Agent ist mit deinem Projekt verbunden und bereit, Code zu lesen, zu bearbeiten, Befehle auszuführen, die Codebasis zu durchsuchen, Todos zu verfolgen und den Kontext über Sitzungen hinweg zu speichern. Wähle unten einen Start-Prompt, schreib deinen eigenen oder gib / für die vollständige Befehls-Palette ein.",
    "workingDirectory": "Arbeitsverzeichnis: {{cwd}}",
    "noKeyTitle": "Noch kein API-Schlüssel konfiguriert",
    "noKeyBody": "Registriere einen Anbieter in den Einstellungen, bevor du eine Nachricht sendest — sonst hat der Agent niemanden, mit dem er reden kann. Anthropic, OpenAI, Google und jeder OpenAI-kompatible Endpunkt funktionieren.",
    "openSettings": "Einstellungen öffnen",
    "pickBackUp": "Fortsetzen",
    "recentPrompts": "Zuletzt verwendete Prompts",
    "quickCommands": "Schnellbefehle",
    "empty": "(leer)",
    "card": {
      "understand": {
        "title": "Verstehen",
        "hint": "Codebasis erkunden und analysieren"
      },
      "create": {
        "title": "Erstellen",
        "hint": "Neue Features und Funktionen bauen"
      },
      "investigate": {
        "title": "Untersuchen",
        "hint": "Probleme debuggen und Ursachen finden"
      },
      "improve": {
        "title": "Verbessern",
        "hint": "Bestehenden Code refactorn und optimieren"
      }
    },
    "slashRef": {
      "help": "alle Slash-Befehle auflisten",
      "diag": "Laufzeitdiagnose",
      "stats": "Token · Cache · Kosten · Dauer",
      "tools": "registrierte Tools anzeigen",
      "memory": "gemerkte Notizen anzeigen",
      "compact": "Kontext verkleinern",
      "clear": "aktuellen Kontext löschen",
      "new": "neue Sitzung"
    }
  },
  "provider": {
    "heading": "Anbieter wählen",
    "keyPlaceholder": "API-Schlüssel einfügen",
    "connect": "Verbinden",
    "connected": "Verbunden"
  },
  "screen": {
    "header": {
      "title": "Willkommen bei WrongStack",
      "subtitle": "Füge mindestens einen API-Schlüssel hinzu, um loszulegen",
      "continue": "Weiter"
    },
    "steps": {
      "addKeys": "API-Schlüssel hinzufügen",
      "pickModel": "Modell wählen",
      "start": "Start",
      "keys": "Schlüssel"
    },
    "security": {
      "title": "Deine Schlüssel bleiben auf deinem Gerät",
      "body": "API-Schlüssel werden verschlüsselt und lokal gespeichert. Sie werden nur an den API-Endpunkt des Anbieters gesendet — nie an uns oder Dritte."
    },
    "errors": {
      "backendUnreachable": "Backend nicht erreichbar",
      "backendNotResponding": "Das Backend reagiert nicht. Es könnte abgestürzt sein oder die Verbindung wurde getrennt.",
      "retry": "Erneut versuchen",
      "modelSwitchTimeout": "Zeitüberschreitung beim Modellwechsel. Bitte erneut versuchen.",
      "noModels": "Keine Modelle verfügbar. Überprüfe deinen API-Schlüssel und versuche es erneut."
    },
    "providers": {
      "popular": "Beliebte Anbieter",
      "more": "Weitere Anbieter",
      "selfHosted": "Selbst gehostet",
      "updating": "Wird aktualisiert...",
      "refresh": "Aktualisieren",
      "refreshTitle": "Anbieterliste aktualisieren",
      "modelsAvailable_one": "{{count}} Modell verfügbar",
      "modelsAvailable_other": "{{count}} Modelle verfügbar",
      "catalogDescription": "{{family}} · {{count}} Modelle"
    },
    "start": {
      "pickAndStart": "Modell wählen und starten",
      "addMoreKeys": "← Weitere Schlüssel hinzufügen",
      "chooseProvider": "Anbieter wählen",
      "chooseModel": "Modell wählen",
      "modelsFor": "Verfügbare Modelle für {{provider}}",
      "activeKeys_one": "{{count}} aktiver Schlüssel",
      "activeKeys_other": "{{count}} aktive Schlüssel",
      "startSession": "Sitzung starten"
    },
    "card": {
      "keySaved": "Schlüssel gespeichert",
      "referral": "Empfehlung",
      "save": "Speichern",
      "getKey": "API-Schlüssel abrufen",
      "copied": "Kopiert",
      "copyReferral": "Empfehlungslink kopieren",
      "share": "Teilen",
      "qrAlt": "{{name}} Empfehlungs-QR-Code"
    },
    "share": {
      "title": "{{name}}-Empfehlung teilen",
      "description": "Teile diesen Empfehlungslink mit Freunden und verdiene Belohnungen!",
      "hint": "Scanne den QR-Code oder kopiere den Link zum Teilen",
      "twitter": "Auf X/Twitter teilen",
      "linkedin": "Auf LinkedIn teilen",
      "telegram": "Auf Telegram teilen",
      "whatsapp": "Auf WhatsApp teilen",
      "reddit": "Auf Reddit teilen",
      "facebook": "Auf Facebook teilen",
      "email": "Per E-Mail teilen"
    },
    "custom": {
      "title": "Benutzerdefinierter / selbst gehosteter Anbieter",
      "description": "Beliebigen OpenAI-kompatiblen Endpunkt hinzufügen (Ollama, vLLM, Together usw.)",
      "localServers": "Lokale Server — zum Ausfüllen klicken",
      "providerId": "Anbieter-ID *",
      "family": "Familie",
      "familyOpenAiCompatible": "OpenAI-kompatibel",
      "baseUrl": "Basis-URL (optional)",
      "apiKey": "API-Schlüssel (optional — einige lokale Anbieter benötigen keinen)",
      "apiKeyPlaceholder": "API-Schlüssel (falls erforderlich)",
      "add": "Anbieter hinzufügen"
    },
    "time": {
      "justNow": "gerade eben",
      "secondsAgo": "vor {{count}} Sek.",
      "minutesAgo": "vor {{count}} Min.",
      "hoursAgo": "vor {{count}} Std.",
      "daysAgo": "vor {{count}} T."
    },
    "toasts": {
      "keySaved": "{{name}} API-Schlüssel gespeichert",
      "keySaveFailed": "{{name}} API-Schlüssel konnte nicht gespeichert werden",
      "referralCopied": "Empfehlungslink in die Zwischenablage kopiert",
      "referralCopyFailed": "Empfehlungslink konnte nicht kopiert werden",
      "providerAdded": "Anbieter \"{{id}}\" hinzugefügt",
      "providerAddFailed": "Anbieter konnte nicht hinzugefügt werden",
      "providersLoadedNew": "{{count}} Anbieter geladen ({{diff}} neu)",
      "providersLoadedRemoved": "{{count}} Anbieter geladen ({{diff}} entfernt)",
      "providersLoadedNoChanges": "{{count}} Anbieter geladen (keine Änderungen)",
      "providersRefreshFailed": "Anbieter konnten nicht aktualisiert werden"
    }
  }
}
